import { mdiChevronLeft } from '@mdi/js';
import Icon from '@mdi/react';
import Link from 'next/link';

import * as styles from '@/styles/components/Content';

type Content = {
  children: React.ReactNode;
};

type ContentHeader = {
  heading: string;
  lead?: string;
  backTo?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

type ContentBlock = {
  spacing?: {
    horizontal?: number;
    vertical?: number;
  };
  children?: React.ReactNode;
};

type ContentParts = {
  children: React.ReactNode;
  display?: string;
};

type BlockHeader = {
  heading: string;
  lead?: string;
};

const Content = ({ children }: Content) => {
  return <div css={styles.root}>{children}</div>;
};

export const Header = ({ heading, lead = '', backTo, children, ...props }: ContentHeader) => {
  return (
    <div css={styles.header}>
      <div css={styles.headerInner}>
        <div css={styles.headerBlock}>
          {backTo && (
            <Link href={backTo} passHref>
              <a css={styles.back}>
                <Icon path={mdiChevronLeft} title='' size='2rem' />
              </a>
            </Link>
          )}
          {props?.onClick && (
            <div onClick={props?.onClick}>
              <a css={styles.back}>
                <Icon path={mdiChevronLeft} title='' size='2rem' />
              </a>
            </div>
          )}
          <h1 css={styles.heading}>{heading}</h1>
        </div>
        {children}
      </div>
      <p css={styles.lead}>{lead}</p>
    </div>
  );
};

export const Block = ({ spacing = {}, children }: ContentBlock) => {
  return <div css={styles.block(spacing)}>{children}</div>;
};

const BlockHeader = ({ heading, lead = '' }: BlockHeader) => {
  return (
    <div css={styles.blockHeader}>
      <h2 css={styles.blockHeading}>{heading}</h2>
      <p css={styles.blockLead}>{lead}</p>
    </div>
  );
};

export const Footer = ({ display, children }: ContentParts) => {
  return <div css={styles.footer(display)}>{children}</div>;
};

const FooterButtons = ({ children }: ContentParts) => {
  return <div css={styles.buttons}>{children}</div>;
};

Block.Header = BlockHeader;
Footer.Buttons = FooterButtons;

Content.Header = Header;
Content.Block = Block;
Content.Footer = Footer;

export default Content;
